import React from 'react';
import styled from 'styled-components';
import HeaderDropdownButton from './HeaderDropdownButton';
import HeaderDropdownListItems from './HeaderDropdownList';

const HeaderDropdownWrapper = styled.div`
  position: relative;
  width: fit-content;
  height: auto;
  #hd-dl-label {
    cursor: pointer;
    font-size: 1.6rem;
    color: var(--color-white);
    width: 100%;
    text-decoration: none;
    border: none;
    background-color: transparent;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    #chevron-down {
      display: unset;
    }
    #chevron-up {
      display: none;
      color: var(--color-brick);
    }
  }
  #hd-dl-list {
    display: none;
    position: absolute;
    background-color: #f1f1f1;
    min-width: 240px;
    width: fit-content;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
  &:hover {
    #hd-dl-label,
    #hd-dl-label > div {
      color: var(--color-black);
      background-color: whitesmoke;
      #chevron-down {
        display: none;
      }
      #chevron-up {
        display: unset;
        color: var(--color-brick);
      }
      #hdb-chevron-down {
        display: none;
      }
      #hdb-chevron-up {
        display: unset;
      }
    }
    #hd-dl-list {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      overflow-x: auto;
    }
  }
`;

const HeaderDropdown = ({ dropdown, ...props }) => {
  return (
    <HeaderDropdownWrapper {...props}>
      <div>
        <div id="hd-dl-label">
          <HeaderDropdownButton
            title={dropdown.title}
            showChevron={dropdown.list.length !== 0 ? true : false}
          />
        </div>
        <div id="hd-dl-list">
          <HeaderDropdownListItems dropdown_list={dropdown.list} />
        </div>
      </div>
    </HeaderDropdownWrapper>
  );
};

export default HeaderDropdown;
